export const DEFAULT_TOAST_TIMEOUT = 5000;
export const DEFAULT_TOOLTIP_DELAY = 500;
